var _g, _path, _rect, _path2, _g2, _g3, _path3, _rect2, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 40,
    viewBox: "0 0 109 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1091_6840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0V3H3V6H0V31H3V34H6V37H9V0H6Z",
    fill: "#DD1A21"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0V3H3V6H0V9H3H6V6H9V3V0H6Z",
    fill: "#05131D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 9,
    width: 3,
    height: 19,
    fill: "#05131D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 37V34H3V31H0V28H3H6V31H9V34V37H6Z",
    fill: "#05131D"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1091_6840)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 37,
    transform: "translate(9)",
    fill: "#DD1A21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    width: 88,
    height: 3,
    fill: "#05131D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.875 25.625H31.75V19.25H28.5625V18.1875H31.75V11.8125H33.875V25.625ZM28.5625 24.5625H26.4375V23.5H25.375V22.4375H23.25V23.5H22.1875V24.5625H20.0625V23.5H21.125V22.4375H22.1875V21.375H23.25V13.9375H20.0625V12.875H28.5625V13.9375H25.375V21.375H26.4375V22.4375H27.5V23.5H28.5625V24.5625ZM45.5625 19.25H43.4375V18.1875H42.375V17.125H40.25V18.1875H39.1875V19.25H37.0625V18.1875H38.125V17.125H39.1875V16.0625H40.25V12.875H37.0625V11.8125H45.5625V12.875H42.375V16.0625H43.4375V17.125H44.5V18.1875H45.5625V19.25ZM49.8125 15H53V16.0625H49.8125V19.25H47.6875V11.8125H49.8125V15ZM38.125 21.375H40.25V20.3125H47.6875V21.375H49.8125V24.5625H47.6875V25.625H40.25V24.5625H38.125V21.375ZM41.3125 22.4375H40.25V23.5H41.3125V24.5625H46.625V23.5H47.6875V22.4375H46.625V21.375H41.3125V22.4375ZM59.375 12.875H62.5625V13.9375H54.0625V12.875H57.25V11.8125H59.375V12.875ZM66.8125 18.1875H70V19.25H66.8125V25.625H64.6875V11.8125H66.8125V18.1875ZM60.4375 24.5625H56.1875V23.5H55.125V22.4375H54.0625V17.125H55.125V16.0625H56.1875V15H60.4375V16.0625H61.5V17.125H62.5625V22.4375H61.5V23.5H60.4375V24.5625ZM57.25 17.125H56.1875V22.4375H57.25V23.5H59.375V22.4375H60.4375V17.125H59.375V16.0625H57.25V17.125ZM84.875 25.625H82.75V11.8125H84.875V25.625ZM74.25 22.4375H75.3125V13.9375H71.0625V12.875H77.4375V22.4375H76.375V23.5H75.3125V24.5625H72.125V23.5H74.25V22.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 34,
    width: 88,
    height: 3,
    fill: "#05131D"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1091_6840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 0V3H103V6H106V31H103V34H100V37H97V0H100Z",
    fill: "#DD1A21"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100 0V3H103V6H106V9H103H100V6H97V3V0H100Z",
    fill: "#05131D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 19,
    transform: "matrix(-1 0 0 1 106 9)",
    fill: "#05131D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100 37V34H103V31H106V28H103H100V31H97V34V37H100Z",
    fill: "#05131D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1091_6840",
    x: 0,
    y: 0,
    width: 12,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0196078 0 0 0 0 0.0745098 0 0 0 0 0.113725 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1091_6840"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1091_6840",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1091_6840",
    x: 9,
    y: 0,
    width: 91,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0196078 0 0 0 0 0.0745098 0 0 0 0 0.113725 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1091_6840"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1091_6840",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1091_6840",
    x: 97,
    y: 0,
    width: 12,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0196078 0 0 0 0 0.0745098 0 0 0 0 0.113725 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1091_6840"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1091_6840",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveImg);
export default __webpack_public_path__ + "static/media/SaveImg.3040cd9c74a4f8330189ed62149a6f52.svg";
export { ForwardRef as ReactComponent };